import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import FormFooter from '../../../common/forms/FormFooter';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import './DeliverInternalParcelForm.css';

const DeliverInternalParcelForm = ({
  handleSubmit,
  internalParcel,
  onCancel,
  loading,
}) => (
  <>
    <Form onSubmit={handleSubmit}>
      <ResourceProperty label="Serie:">
        {internalParcel.documentSeries}
      </ResourceProperty>
      <ResourceProperty label="Número de serie:">
        {internalParcel.documentCode}
      </ResourceProperty>
      <ResourceProperty label="Origen:">
        {internalParcel.sourceCityName}
      </ResourceProperty>
      <ResourceProperty label="Destino:">
        {internalParcel.destinationCityName}
      </ResourceProperty>
      <hr />
      <FormGroup row>
        <FormItem label="Usuario del Consignado:">
          <Field
            name="username"
            component={TextInput}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Contraseña del Consignado:">
          <Field
            name="password"
            className="password"
            component={TextInput}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonColor="success"
        saveButtonText="Entregar"
        saveButtonDisabled={loading}
        saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-pencil'}
      >
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  </>
);

DeliverInternalParcelForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  internalParcel: PropTypes.shape({
    documentSeries: PropTypes.string,
    documentCode: PropTypes.number,
    sourceCityName: PropTypes.string,
    destinationCityName: PropTypes.string,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DeliverInternalParcelForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.CargoUnit.InternalTransfer.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'DeliverInternalParcelForm',
})(DeliverInternalParcelForm);

export default connect(mapStateToProps, null)(formComponent);
